import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useId, useRef } from "react";
export function Dialog({ open, title, onClose, children, actions, dismissible = true }) {
    const ref = useRef(null);
    const titleId = useId();
    useEffect(() => {
        const element = ref.current;
        if (element === null)
            return;
        if (open && !element.open) {
            element.showModal();
        }
        else if (!open && element.open) {
            element.close();
        }
    }, [open]);
    return (_jsx("dialog", { ref: ref, className: "wt-dialog-host", "aria-labelledby": titleId, onCancel: (event) => {
            if (!dismissible) {
                // The platform would close the element itself; keep it open and leave the state alone.
                event.preventDefault();
                return;
            }
            onClose();
        }, children: _jsx("div", { className: "dialog-backdrop", children: _jsxs("div", { className: "dialog", children: [_jsx("h2", { id: titleId, className: "dialog-title", children: title }), _jsx("div", { className: "dialog-body", children: children }), actions === undefined ? null : _jsx("div", { className: "dialog-actions", children: actions })] }) }) }));
}
//# sourceMappingURL=dialog.js.map